// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

export const SpaceSettingsNavigationV2Portal = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-navigationSpaceSettingsNavigationPortal" */ './navigation/SpaceSettingsNavigationPortal.tsx'
			)
		).SpaceSettingsNavigationPortal,
	name: 'SpaceSettingsNavigationPortal',
});

export const SpaceSettingsSidebarLinks = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-sidebarSpaceSettingsSidebarLinks" */ './sidebar/SpaceSettingsSidebarLinks.tsx'
			)
		).SpaceSettingsSidebarLinks,
	name: 'SpaceSettingsSidebarLinks',
});

export const SpaceSettingsV2ForgeApp = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-forge-appsForgeApp" */ './forge-apps/ForgeApp.tsx'))
			.ForgeApp,
	name: 'SpaceSettingsV2ForgeApp',
});

export const SpaceSettingsV2LandingPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-landing-pageLandingPage" */ './landing-page/LandingPage.tsx'
			)
		).LandingPage,
	name: 'SpaceSettingsV2LandingPage',
});

export const ContentStateSettings = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-pagesContentStateSettings" */ './pages/ContentStateSettings.tsx'
			)
		).ContentStateSettings,
	name: 'ContentStateSettings',
});

export const ArchiveSpace = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-pagesArchiveSpace" */ './pages/ArchiveSpace.tsx'))
			.ArchiveSpace,
	name: 'ArchiveSpace',
});

export const EditorConversion = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-pagesArchiveSpace" */ './pages/EditorConversion.tsx'))
			.EditorConversion,
	name: 'EditorConversion',
});

export const DataClassificationSpaceSettings = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-dataClassificationSpaceSettings" */ './pages/DataClassificationSpaceSettings.tsx'
			)
		).DataClassificationSpaceSettings,
	name: 'DataClassificationSpaceSettings',
});

export const WatermarkConfigurationSpaceSettings = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-watermarkConfigurationSpaceSettings" */ './pages/WatermarkConfigurationSpaceSettings.tsx'
			)
		).WatermarkConfigurationSpaceSettings,
	name: 'WatermarkConfigurationSpaceSettings',
});

export const ExportSpaceUnavailable = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-exportSpaceUnavailable" */ './pages/ExportSpaceUnavailable.tsx'
			)
		).ExportSpaceUnavailable,
	name: 'ExportSpaceUnavailable',
});

export const ExportSpace = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-pagesPDFExport" */ './pages/ExportSpace.tsx'))
			.ExportSpace,
	name: 'ExportSpace',
});

export const LegacyContent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-pagesPDFExport" */ './pages/legacy-content/LegacyContent.tsx'
			)
		).LegacyContent,
	name: 'LegacyContent',
});

export const EditFeatures = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-pagesEditFeatures" */ './pages/EditFeatures.tsx'))
			.EditFeatures,
	name: 'EditFeatures',
});

export const LazyPdfExportPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PdfExportPage" */ './pages/look-and-feel/pdf-export/PdfExportPage.tsx'
			)
		).PdfExportPage,
	name: 'PdfExportPage',
});

export const LazyNcsPdfStylingPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PdfExportPage" */ './pages/look-and-feel/pdf-export/PdfExportPage.tsx'
			)
		).PdfExportPage,
	name: 'PdfExportPage',
});

export const NcsPdfStylingPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageLayoutPage" */ './pages/look-and-feel/no-code-styling/NcsPdfStylingPage.tsx'
			)
		).NcsPdfStylingPage,
	name: 'NcsPdfStylingPage',
});

export const LazyPageLayoutPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageLayoutPage" */ './pages/look-and-feel/page-layout/PageLayoutPage.tsx'
			)
		).PageLayoutPage,
	name: 'PageLayoutPage',
});

export const LazyThemesPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ThemesPage" */ './pages/look-and-feel/themes/ThemesPage.tsx'
			)
		).ThemesPage,
	name: 'ThemesPage',
});

export const LazyTemplatesPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TemplatesPage" */ './pages/look-and-feel/templates/TemplatesAndBlueprintsPage.tsx'
			)
		).TemplatesAndBlueprintsPage,
	name: 'TemplatesPage',
});

export const SpaceSettingsSideNavigation = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsSideNavigation" */ './side-navigation/SpaceSettingsSideNavigation.tsx'
			)
		).SpaceSettingsSideNavigation,
	name: 'SpaceSettingsSideNavigation',
});

export const LazySpaceDetailsPage = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceDetailsPage" */ './pages/SpaceDetails/SpaceDetailsPage.tsx'
			)
		).SpaceDetailsPage,
	name: 'SpaceDetailsPage',
});

export { SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE } from './pages/SpaceDetails/spaceDetailsConstants.ts';
